import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from "@angular/material/button-toggle";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuTrigger } from "@angular/material/menu";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-widget-period-filters",
  standalone: true,
  imports: [
    SharedModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatIcon,
    MatMenu,
    MatMenuTrigger,
  ],
  templateUrl: "./widget-period-filters.component.html",
  styleUrl: "./widget-period-filters.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetPeriodFiltersComponent {
  // Two-way bindings (model) — chaque widget consommateur peut binder
  // uniquement les filtres qui l'intéressent.
  period = model<string>("m");
  timeScale = model<string>("YTD");
  comparison = model<string | null>(null);

  /**
   * Inputs de visibilité — permettent à chaque widget de n'afficher que
   * les filtres pertinents tout en gardant la même UI (icône `tune` +
   * popover). Default = tout afficher (rétrocompat avec les widgets qui
   * utilisent les 3 filtres comme `widget-ca-par-periode`).
   */
  showPeriod = input<boolean>(true);
  showTimeScale = input<boolean>(true);
  showComparison = input<boolean>(true);

  onPeriodChange(value: string) {
    this.period.set(value);
  }

  onTimeScaleChange(value: string) {
    this.timeScale.set(value);
  }

  onComparisonChange(value: string) {
    this.comparison.set(value || null);
  }
}
